
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/help/imprint",
      function () {
        return require("private-next-pages/[locale]/help/imprint.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/help/imprint"])
      });
    }
  